/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Brands_Playdata_HrefInputs */

const ja_home_brands_playdata_href = /** @type {(inputs: Home_Brands_Playdata_HrefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.playdata.gg/ja/home`)
};

const en_home_brands_playdata_href = /** @type {(inputs: Home_Brands_Playdata_HrefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://playdata.gg`)
};

/**
* | output |
* | --- |
* | "https://playdata.gg" |
*
* @param {Home_Brands_Playdata_HrefInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const home_brands_playdata_href = /** @type {((inputs?: Home_Brands_Playdata_HrefInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Brands_Playdata_HrefInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_brands_playdata_href(inputs)
	return en_home_brands_playdata_href(inputs)
});